module.exports = __webpack_public_path__ + "static/media/inventoryPut.9fc2af8f.mp3";